import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks";
// import { nsoFlowFetchNsoRequestData } from "redux/nsoFlow/nsoFlowSlice";
import ConfigurationPanel from "components/ConfigurationPanel";
import { Step, StepButton, Stepper } from "@mui/material";
import { DataCoreFlowsteps } from "utils/defaultValues";
import { MenuItem } from "primereact/menuitem";
// import RequestResponseTab from "components/RequestResponseTab";
// import { Tag } from "primereact/tag";
// import ConfigurationPanel from "components/ConfigurationPanel";
import NsoRequest from "./NsoFlowSteps/NsoRequest/NsoRequest";
import VehicleDetails from "./NsoFlowSteps/VehicleDetails/VehicleDetails";
import NonBuildableSpec from "./NsoFlowSteps/NonBuildableSpec/NonBuildableSpec";
import GetInlineAccessoryFromPcpsComponent from "./NsoFlowSteps/GetInlineAccessoryFromPcps/GetInlineAccessoryFromPcps";
import PostOrderChangetoSimEngine from "./NsoFlowSteps/PostOrderChangetoSimEngine/PostOrderChangetoSimEngine";
// import { handleNsoStepFunctionData } from "utils/commonFunctions";
import Toms from "./NsoFlowSteps/Toms/Toms";
import { handleStepFunctionData } from "utils/transpile";
import { DataCoreFlowstep } from "types/Flowstep/Flowstep.interface";

function NsoSteps() {
  const id: string = useParams().id!;
  const nsoSelector = useAppSelector((state) => state.nsoFlow.nsoFlow);
  const homeSelector = useAppSelector((state) => state.home.home);
  const nsoError = useAppSelector((state) => state.errorStep.nsoError);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const pathSegment = location.pathname.split("/").filter(Boolean);
  const [stepFunctionData, setStepFunctionData] = useState(DataCoreFlowsteps);
  const errorStep: {
    id: number;
    errorLambda: string | null;
    name: string;
    step: number;
    displayStep: number;
    displayName: string;
    color: string;
    errorMsg?: string;
    error?: string;
  } | null = nsoError;
  const effectran = useRef(false);
  useEffect(() => {
    if (effectran.current === false && id) {
      // console.log("inside useEffect");

      const getStepFunctionsData = async () => {
        try {
          const modifiedData = await handleStepFunctionData({
            flowDetailId: id,
            flowStatus: homeSelector?.status,
            flowSteps: stepFunctionData,
            type: "nso",
          });
          if (typeof modifiedData !== "boolean" && modifiedData !== undefined) {
            setStepFunctionData(modifiedData as DataCoreFlowstep[]); // Cast modifiedData to DataCoreFlowstep[]
          }
        } catch (error) {
          console.error("An error occurred:", error);
        }
      };
      getStepFunctionsData();
      effectran.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, stepFunctionData, id, pathSegment[0]]);

  const itemRenderer = (item: MenuItem, itemIndex: number) => {
    const isActiveItem = nsoSelector?.activeStep === itemIndex;
    // const backgroundColor =  item.color === "#fff"
    //     ? "#ea580c"
    //     : item.color;
    const backgroundColor = errorStep?.name === item.data.key ? "#fc0808" : isActiveItem ? item.data.color : "white";
    // const textColor = isActiveItem ? "black" : "black";
    const textColor = "black";
    return (
      <div className="flex flex-col items-center justify-center w-full">
        <div
          className={`inline-flex align-items-center justify-content-center 
align-items-center border-circle border-primary border-1 ${
            item.data.key === null ? "cursor-not-allowed" : "cursor-pointer"
          }
rounded-full items-center justify-center text-sm z-10 mb-2`}
          style={{
            backgroundColor:
              errorStep?.name === "checkVehicleElgibility" && item.data.key === "Get_Vehicle_Data"
                ? "#fc0808"
                : backgroundColor,
            color: textColor,
          }}
          onClick={() => {
            if (item.data.key !== null) {
              dispatch({ type: "nsoFlow/nsoFlowSetActiveStep", payload: itemIndex });
            }
          }}
        >
          <svg
            width="30px"
            height="30px"
            viewBox="2 2 44 44"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="Icon-Resource/Compute/Res_AWS-Lambda_Lambda-Function_48"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <path
                d="M24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 C44,35.028 35.028,44 24,44 L24,44 Z M24,2 C11.869,2 2,11.869 2,24 C2,36.131 11.869,46 24,46 C36.131,46 46,36.131 46,24 C46,11.869 36.131,2 24,2 L24,2 Z M17.231,35.25 L11.876,35.25 L18.221,21.959 L20.902,27.492 L17.231,35.25 Z M19.114,19.215 C18.946,18.87 18.597,18.651 18.214,18.651 L18.211,18.651 C17.826,18.652 17.477,18.874 17.312,19.221 L9.389,35.819 C9.24,36.129 9.262,36.493 9.445,36.783 C9.628,37.074 9.947,37.25 10.291,37.25 L17.864,37.25 C18.251,37.25 18.603,37.027 18.769,36.678 L22.915,27.915 C23.044,27.642 23.043,27.323 22.911,27.051 L19.114,19.215 Z M36.125,35.25 L30.673,35.25 L20.761,13.953 C20.597,13.601 20.243,13.375 19.854,13.375 L16.251,13.375 L16.255,9.25 L23.475,9.25 L33.339,30.545 C33.503,30.898 33.856,31.125 34.246,31.125 L36.125,31.125 L36.125,35.25 Z M37.125,29.125 L34.885,29.125 L25.021,7.83 C24.856,7.477 24.503,7.25 24.113,7.25 L15.256,7.25 C14.704,7.25 14.257,7.697 14.256,8.249 L14.25,14.374 C14.25,14.64 14.355,14.894 14.543,15.082 C14.73,15.27 14.984,15.375 15.25,15.375 L19.217,15.375 L29.129,36.672 C29.293,37.024 29.646,37.25 30.035,37.25 L37.125,37.25 C37.678,37.25 38.125,36.803 38.125,36.25 L38.125,30.125 C38.125,29.572 37.678,29.125 37.125,29.125 L37.125,29.125 Z"
                id="Amazon-Lambda-Lambda-Function_Resource-Icon_light-bg"
                fill={textColor}
              />
            </g>
          </svg>
        </div>
        <div
          className={`h-12 w-24 text-center text-sm cursor-pointer capitalize ${
            nsoSelector?.activeStep === itemIndex ? "text-black font-bold" : "text-gray-500"
          }`}
        >
          {item.data.name}
        </div>
      </div>
    );
  };
  const items: MenuItem[] = [
    {
      data: {
        name: "NSO Request",
        // key: stepFunctionData[0].color === "#fff" ? null : "NSO_Request",
        key: stepFunctionData[0].enabled ? "NSO_Request" : null,
        color: stepFunctionData[0].color,
      },
      template: (item) => itemRenderer(item, 0),
    },
    {
      data: {
        name: "Vehicle Details",
        // key: stepFunctionData[1].color === "#fff" ? null : "Get_Vehicle_Data",
        key: stepFunctionData[1].enabled ? "Get_Vehicle_Data" : null,
        color: stepFunctionData[1].color,
      },
      template: (item) => itemRenderer(item, 1),
    },
    // {
    //   data: {
    //     name: "Check Vehicle Eligibility",
    //     // key: stepFunctionData[3].color === "#fff" ? null : "checkVehicleElgibility",
    //     key: stepFunctionData[3].enabled ? "checkVehicleElgibility" : null,
    //     // key: null,
    //     color: stepFunctionData[3].color,
    //   },
    //   template: (item) => itemRenderer(item, 2),
    // },
    {
      data: {
        name: "Get Spec From Toms ",
        // key: stepFunctionData[5].color === "#fff" ? null : "Get_Spec_From_Toms",
        key: stepFunctionData[5].enabled ? "Get_Spec_From_Toms" : null,
        color: stepFunctionData[5].color,
      },
      template: (item) => itemRenderer(item, 3),
    },
    {
      data: {
        name: "Update Non Buildable Spec",
        // key: stepFunctionData[7].color === "#fff" ? null : "Update_Non_Buildable_Spec",
        key: stepFunctionData[7].enabled ? "Update_Non_Buildable_Spec" : null,
        // key: null,
        color: stepFunctionData[7].color,
      },
      template: (item) => itemRenderer(item, 4),
    },
    {
      data: {
        name: "Get Inline Accessory From Pcps",
        // key: stepFunctionData[8].color === "#fff" ? null : "Get_Inline_Accessory_From_Pcps",
        key: stepFunctionData[8].enabled ? "Get_Inline_Accessory_From_Pcps" : null,
        color: stepFunctionData[8].color,
      },
      template: (item) => itemRenderer(item, 5),
    },
    {
      data: {
        name: "Post Order Change to SimEngine ",
        // key: stepFunctionData[9].color === "#fff" ? null : "Post_Order_Change_to_SimEngine",
        key: stepFunctionData[9].enabled ? "Post_Order_Change_to_SimEngine" : null,
        // key: "Post_Order_Change_to_SimEngine",
        color: stepFunctionData[9].color,
      },
      template: (item) => itemRenderer(item, 6),
    },
  ];

  const componentRenderer = () => {
    switch (nsoSelector.activeStep) {
      case 0:
        return <NsoRequest id={id} />;
      case 1:
        return <VehicleDetails />;
      case 2:
        return <Toms id={id} />;
      case 3:
        return <NonBuildableSpec id={id} />;
      case 4:
        return <GetInlineAccessoryFromPcpsComponent id={id} />;
      case 5:
        return <PostOrderChangetoSimEngine id={id} />;
      default:
        return <div className="text-center text-gray-500 font-bold text-xl">No Step Selected</div>;
    }
  };
  return (
    <div className="flex flex-col py-2 px-2 bg-gray-100 rounded-lg ">
      <ConfigurationPanel id={id} />
      <div className="px-6 my-4 bg-gray-100  h-14 rounded-lg items-center align-center flex">
        <span className="text-center text-2xl font-bold text-black App">Vehicle Flow {`: ${id}`}</span>
      </div>
      <div>
        <div className="card mx-4 flex flex-col gap-4">
          <div>
            {/* <Steps model={items} activeIndex={activeIndex} readOnly={false} className="m-2 pt-4" /> */}
            <Stepper activeStep={7} alternativeLabel>
              {items.map((obj, index) => (
                <Step key={obj.data.name}>
                  <StepButton icon={itemRenderer(obj, index)}></StepButton>
                </Step>
              ))}
            </Stepper>
          </div>
          <div className="pt-4">
            {nsoError
              ? nsoError?.name === "checkVehicleElgibility" && (
                  <div className="flex flex-row justify-center text-red-500 font-bold text-xl">
                    {nsoError?.errorMsg} {nsoError?.error}
                  </div>
                )
              : null}
            {items[nsoSelector?.activeStep]?.data.key === nsoError?.name ? (
              <div className="flex flex-col ">
                {" "}
                <div className="flex flex-row justify-center text-red-500 font-bold text-xl">
                  {nsoError?.errorMsg} {nsoError?.error}
                </div>
                {componentRenderer()}
              </div>
            ) : (
              <div>{componentRenderer()}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NsoSteps;
